import type { SessionData } from '../types';

export function estimateTotalDuration(session: SessionData): number {
  let totalSeconds = 0;
  for (const ex of session.exercises) {
    const duration = ex.targetDurationSeconds ?? (ex.targetReps ?? 0) * (ex.timingSecondsPerRep ?? 3);
    // Unilateral exercises take 2x time (both sides)
    const lateralityMultiplier =
      ex.lateralityType === 'UnilateralSequential' || ex.lateralityType === 'UnilateralAlternating' ? 2 : 1;
    const sets = ex.targetSets ?? 1;
    // Time for all sets of this exercise
    const exerciseTime = duration * lateralityMultiplier * sets;
    // Rest between sets (sets - 1 rest periods)
    const setRestTime = sets > 1 ? (session.restBetweenSetsSeconds ?? 60) * (sets - 1) : 0;
    totalSeconds += exerciseTime + setRestTime;
  }
  totalSeconds *= session.rounds;
  totalSeconds += session.restBetweenExercisesSeconds * (session.exercises.length - 1) * session.rounds;
  totalSeconds += session.restBetweenRoundsSeconds * (session.rounds - 1);
  totalSeconds += session.setupTimeSeconds * session.rounds;
  return totalSeconds;
}
